import { useState, useEffect, useCallback } from 'react';

// Konami code sequence
const KONAMI_CODE = [
  'ArrowUp', 'ArrowUp',
  'ArrowDown', 'ArrowDown',
  'ArrowLeft', 'ArrowRight',
  'ArrowLeft', 'ArrowRight',
  'KeyB', 'KeyA'
];

export function useEasterEggs() {
  const [crtActive, setCrtActive] = useState(false);
  const [terminalOpen, setTerminalOpen] = useState(false);
  const [konamiIndex, setKonamiIndex] = useState(0);

  // Konami code listener
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Don't trigger in input fields
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) {
        return;
      }

      const expected = KONAMI_CODE[konamiIndex];
      
      if (e.code === expected) {
        const next = konamiIndex + 1;
        setKonamiIndex(next);
        
        if (next === KONAMI_CODE.length) {
          setCrtActive((prev) => {
            const newState = !prev;
            if (newState) {
              document.documentElement.classList.add('crt');
            } else {
              document.documentElement.classList.remove('crt');
            }
            return newState;
          });
          setKonamiIndex(0);
        }
      } else {
        // Reset on wrong key, but allow the current key to start a new sequence
        setKonamiIndex(e.code === KONAMI_CODE[0] ? 1 : 0);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [konamiIndex]);

  // Ctrl+Shift+K to toggle terminal
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) {
        return;
      }

      if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setTerminalOpen((prev) => !prev);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  const openTerminal = useCallback(() => setTerminalOpen(true), []);
  const closeTerminal = useCallback(() => setTerminalOpen(false), []);

  return { crtActive, terminalOpen, openTerminal, closeTerminal };
}
